<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">add</i>
                        </div>
                        <h4 class="card-title">Novo Lead</h4>
                    </div>
                    <b-form @submit="onSubmit" novalidate="novalidate">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-8">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': form.name != '', 'has-danger' : validation.name != '' }">
                                        <label for="name" class="bmd-label-floating">Nome *</label>
                                        <input refs="name" type="text" class="form-control" v-model="form.name" />
                                        <label v-if="validation.name != ''" id="name-error" class="error" for="name">{{ validation.name }}</label>
                                    </div>

                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': form.phone != '', 'has-danger' : validation.phone != '' }">
                                        <label for="phone" class="bmd-label-floating">Telefone *</label>
                                        <the-mask refs="phone" type="text" class="form-control" v-model="form.phone" :mask="['(##) #####-####', '(##) #####-####']"></the-mask>
                                        <label v-if="validation.phone != ''" id="phone-error" class="error" for="phone">{{ validation.phone }}</label>
                                    </div>

                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': form.email != '', 'has-danger' : validation.email != '' }">
                                        <label for="email" class="bmd-label-floating">E-mail</label>
                                        <input refs="email" type="text" class="form-control" v-model="form.email" />
                                        <label v-if="validation.email != ''" id="email-error" class="error" for="email">{{ validation.email }}</label>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group"
                                         v-bind:class="{'is-filled': form.lead_status_id != '', 'has-danger' : validation.lead_status_id != '' }">
                                        <label for="name" class="bmd-label-floating">Status *</label>
                                    </div>
                                    <div class="form-group"
                                         v-bind:class="{'is-filled': form.lead_status_id != '', 'has-danger' : validation.lead_status_id != '' }">
                                        <select style="padding-left: 5px;border-top: 1px solid #cccccc;border-left: 1px solid #cccccc;border-right: 1px solid #cccccc" placeholder="Status" v-model="form.lead_status_id" class="form-control">
                                            <option v-for="option in status" v-bind:value="option.id">
                                                {{ option.status }}
                                            </option>
                                        </select>
                                        <br clear="all">
                                    </div>
                                    <div class="form-group"
                                         v-bind:class="{'is-filled': form.lead_status_id != '', 'has-danger' : validation.lead_status_id != '' }">
                                        <label v-if="validation.lead_status_id != ''" id="status-error" class="error" for="status">{{ validation.lead_status_id }}</label>
                                    </div>
                                    <div class="form-group"
                                         v-bind:class="{'is-filled': form.user_id != '', 'has-danger' : validation.user_id != '' }">
                                        <label for="responsavel" class="bmd-label-floating">Responsável</label>
                                    </div>
                                    <div class="form-group"
                                         v-bind:class="{'is-filled': form.user_id != '', 'has-danger' : validation.user_id != '' }">
                                        <select style="padding-left: 5px;border-top: 1px solid #cccccc;border-left: 1px solid #cccccc;border-right: 1px solid #cccccc" placeholder="Status" v-model="form.user_id" class="form-control">
                                            <option v-for="responsible in responsibles" v-bind:value="responsible.id">
                                                {{ responsible.name }}
                                            </option>
                                        </select>
                                        <br clear="all">
                                    </div>
                                    <div class="form-group"
                                         v-bind:class="{'is-filled': form.user_id != '', 'has-danger' : validation.user_id != '' }">
                                        <label v-if="validation.user_id != ''" id="responsavel-error" class="error" for="responsible">{{ validation.user_id }}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': form.street != '', 'has-danger' : validation.street != '' }">
                                        <label for="street" class="bmd-label-floating">Rua</label>
                                        <input refs="street" type="text" class="form-control" v-model="form.street" />
                                        <label v-if="validation.street != ''" id="street-error" class="error" for="street">{{ validation.street }}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': form.neighborhood != '', 'has-danger' : validation.neighborhood != '' }">
                                        <label for="neighborhood" class="bmd-label-floating">Bairro</label>
                                        <input refs="neighborhood" type="text" class="form-control" v-model="form.neighborhood" />
                                        <label v-if="validation.neighborhood != ''" id="neighborhood-error" class="error" for="neighborhood">{{ validation.neighborhood }}</label>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': form.city != '', 'has-danger' : validation.city != '' }">
                                        <label for="city" class="bmd-label-floating">Cidade</label>
                                        <input refs="city" type="text" class="form-control" v-model="form.city" />
                                        <label v-if="validation.city != ''" id="city-error" class="error" for="city">{{ validation.city }}</label>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': form.state != '', 'has-danger' : validation.state != '' }">
                                        <label for="state" class="bmd-label-floating">Estado</label>
                                        <input refs="state" type="text" class="form-control" v-model="form.state" />
                                        <label v-if="validation.state != ''" id="state-error" class="error" for="state">{{ validation.state }}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-8">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': form.details != '', 'has-danger' : validation.details != '' }">
                                        <label for="details" class="bmd-label-floating">Detalhes</label>
                                        <textarea refs="details" type="text" class="form-control" v-model="form.details"></textarea>
                                        <label v-if="validation.details != ''" id="details-error" class="error" for="details">{{ validation.details }}</label>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group is-filled">
                                        <label for="value" class="bmd-label-floating">Valor de Interesse *</label>
                                        <money v-model="form.value" maxlength="13" class="form-control" v-bind="money" placeholder=""></money>
                                        <label v-if="validation.value != ''" id="value-error" class="error" for="value">{{ validation.value }}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <form-buttons/>
                        </div>
                    </b-form>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <p class="text-center">ou</p>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">add</i>
                        </div>
                        <h4 class="card-title">Importar Arquivo</h4>
                    </div>
                    <b-form @submit="onSubmitFile" novalidate="novalidate">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>Arquivo</label>
                                    </div>
                                    <input ref="file" type="file" class="form-control"  @change="onSelect">
                                    <p class="pt-2"><i>* O arquivo deve ser um .csv válido, <a href="/assets/files/exemplo_leads.csv">conforme esse modelo</a></i></p>

                                    <b v-if="imports.length > 0">Resultado da Importação:</b>
                                    <ul v-for="i in imports" class="pt-2">
                                        <li v-bind:style="{ color: i.color}">{{i.msg}}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <form-buttons/>
                        </div>
                    </b-form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import JwtService from '@/services/jwt.service';
    import UserService from '@/services/modules/users.service';
    export default {
        computed: {
            status: {
                set(_items) {
                    this.$store.commit("lead_status/setList", _items);
                },
                get() {
                    return this.$store.state.lead_status.itens.filter(ele => {
                        return ele.status !== 'Vendido'
                    });
                }
            },
            responsibles: {
                set(_items) {
                    this.$store.commit("users/setList", _items);
                },
                get() {
                    return this.$store.state.users.itens;
                }
            }
        },
        data() {
            return {
                salesmans: [],
                form: {
                    name: '',
                    lead_status_id: '',
                    phone: '',
                    email: '',
                    street: '',
                    neighborhood: '',
                    city: '',
                    state: '',
                    details: '',
                    user_id: null,
                    value: ''
                },
                file_form: {
                    file: null,
                },
                money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: '',
                    suffix: '',
                    precision: 2,
                    masked: false
                },
                validation: {
                    name: '',
                    lead_status_id: '',
                    phone: '',
                    email: '',
                    street: '',
                    neighborhood: '',
                    city: '',
                    state: '',
                    details: '',
                    user_id: '',
                    value: ''
                },
                imports: []
            };
        },
        created: function () {
            this.status = [];
            this.imports = [];
            this.responsibles = [];
            this.import = [];
            this.getData();
            this.getDataSalesmans();
        },
        methods: {

            onSelect() {
                const self = this;
                self.import = [];
                const file = this.$refs.file.files[0];
                const reader = new FileReader();

                reader.onload = e => {
                    const data = e.target.result.split('\n');
                    for (let line of data) {
                        const array = line.split(';');
                        if (array[0] != 'Nome' && array[1] != 'Rua') {
                            let s = null;

                            for (let status of self.status) {
                                if (status.status.toLowerCase() == (array[7] || '').toLowerCase()) {
                                    s = status.id;
                                }
                            }

                            self.import.push({
                                name: array[0],
                                street: array[1],
                                neighborhood: array[2],
                                city: array[3],
                                state: array[4],
                                phone: array[5],
                                email: array[6],
                                lead_status_id: s || null,
                                details: array[8],
                                value: array[9]
                            })
                        }
                        console.log(`line`, line);
                    }
                }
                reader.readAsText(file, 'ISO-8859-1');
            },

            async getDataSalesmans() {
                var self = this;

                self.$root.$emit("onLoading");

                var params = 'branch_id=' + JwtService.getBranchId() + '&salesmens=' + true;
                // + '&profile_id=' + UserService.typeProfiles.salesman
                //+ '&team_id=' + _teamId;

                const response = UserService.all(params);

                await response.then(function (_users) {
                    self.responsibles = _users;
                    self.$root.$emit("onLoading");
                });

                console.log('salesmans ', self.salesmans);

                response.catch(function () {
                    self.$root.$emit("onLoading");
                });
            },
            async getData() {
                var self = this;
                const response = self.$store.dispatch("lead_status/all");

                response.then(function (y) {
                    console.log(`status`, y);
                    self.status = y;
                });

                response.catch(function () {
                });
            },
            async getUsers() {
                var self = this;

                self.$root.$emit('onLoading');

                const response = self.$store.dispatch('users/all');

                response.then(function (x) {
                    self.responsibles = x;
                    console.log(`responsibles`, self.responsibles);
                    self.$root.$emit('onLoading');
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                });
            },
            clearForm() {
                var self = this;
                Object.keys(this.form).forEach(function (key, index) {
                    self.form[key] = '';
                });
            },
            onSubmit(_ev) {
                _ev.preventDefault();
                var self = this;
                var valid = true;
                self.validation.name = '';
                self.validation.phone = '';
                self.validation.value = '';

                if (self.form.name == '') {
                    self.validation.name = 'Campo obrigatório!';
                    valid = false;
                }

                if (self.form.phone == '') {
                    self.validation.phone = 'Campo obrigatório!';
                    valid = false;
                }
                if (self.form.lead_status_id == '') {
                    self.validation.lead_status_id = 'Campo obrigatório!';
                    valid = false;
                }
                if (self.form.value == '') {
                    self.validation.value = 'Campo obrigatório!';
                    valid = false;
                }

                if (valid) {
                    self.$root.$emit('onLoading');

                    const response = self.$store.dispatch('lead/add', this.form);

                    response.then(function () {
                        self.$root.$emit('onLoading');
                        self.$notify.success("Lead cadastrado com sucesso!");
                        self.clearForm();
                        // self.$router.push({'name': 'leads.supervise'});
                    });

                    response.catch(function (err) {
                        self.$root.$emit('onLoading');

                        if (err.status === 422) {
                            if (err.data.message !== undefined) {
                                self.$notify.error(err.data.message);
                            }

                            if (err.data.hasOwnProperty('errors') && err.data.errors.name !== undefined) {
                                self.validation.name = err.data.errors.name[0];
                            }

                        }
                    });
                }
            },
            onSubmitFile(_ev) {
                _ev.preventDefault();

                const self = this;

                self.imports = [];

                for (let item of self.import) {
                    self.$root.$emit('onLoading');
                    const response = self.$store.dispatch('lead/add', item);

                    response.then(function (x) {
                        self.$root.$emit('onLoading');
                        self.imports.push({msg: item.name + ' importado com sucesso!', color: 'green'})
                        console.log(self.imports);
                    });

                    response.catch(function (e) {
                        console.log(e);
                        self.$root.$emit('onLoading');
                        self.imports.push({msg: 'Erro ao importar "' + item.name + '". (' + (e.data.message || e.data) + ')', color: 'red'})
                        console.log(self.imports);
                    });
                }
            }
        }
    };
</script>
